// Structural data only — all display text comes from i18n (data.* keys), looked up by id.
export const PLANS = [
  { id: "essential", accent: "signal", featured: false },
  { id: "nomad", accent: "signal", featured: true },
  { id: "plus", accent: "signal", featured: false },
  { id: "trader", accent: "gold", featured: false },
  { id: "seasonal", accent: "health", featured: false },
  { id: "family", accent: "health", featured: false },
  { id: "black", accent: "gold", featured: false, premium: true },
];

export const PILLARS = [
  { id: "assistance", icon: "Globe2", accent: "signal" },
  { id: "smartbag", icon: "Luggage", accent: "signal", to: "/smartbag" },
  { id: "telemedicine", icon: "Stethoscope", accent: "health", to: "/telemedicine" },
  { id: "connectivity", icon: "Signal", accent: "signal", to: "/connectivity" },
  { id: "risk", icon: "ShieldAlert", accent: "gold", to: "/risk-options" },
  { id: "preexisting", icon: "HeartPulse", accent: "health" },
];

export const SEGMENTS = [
  { id: "nomads", image: "nomad" },
  { id: "seasonal", image: "seasonal" },
  { id: "traders", image: "conference" },
  { id: "relocation", image: "family" },
  { id: "families", image: "family" },
  { id: "hnw", image: "executive" },
];
